module.exports = __webpack_public_path__ + "img/programme7.72b21990.png";